<template>
  <div class="section">
    <section-header v-if="!hideTitle"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    @extended=setExtended
                    @closeDialog=closeDialog
                    ref="DPAE">
    </section-header>

    <div v-if="extended">
      <div :class="dialog ? 'p-15' : 'pt-2 pb-5'">
        <div class="text" v-html="getDpaeInfo()"></div>
      </div>

      <div class="d-flex flex-row-reverse">
        <div v-for="(state, index) in state.actions" :key="index">
          <loader-button class="ms-2"
                         type="submit"
                         :label="state"
                         @callback="callBack(index)">
          </loader-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import CrudContrat from '@/generated/cruds/CrudContrat';
import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
import State from '@/generated/classes/State';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { defineComponent } from "vue";

export default defineComponent({
  extends: CrudContrat,
  name: 'SectionContratDpae',
  components: {},
  props: {
    hideTitle: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      lockAction: false,
      activeState: new State(),
      dpaeDate: null as Date | null,
    };
  },
  computed: {
    ressource(): any { return RessourceGenSection(GenSection.DPAE); },
    state(): State {
      if (this.activeState.objId != this.editContrat.id ||
        this.activeState.statut != this.editContrat.dpaeStatut ||
        this.dpaeDate != this.editContrat.dpaeDate) {
        this.activeState.objType = ObjTypes.DPAE;
        this.activeState.objId = this.editContrat.id;
        this.activeState.statut = this.editContrat.dpaeStatut;
        this.dpaeDate = this.editContrat.dpaeDate;
        this.callBack();
      }
      return this.activeState;
    },
  },
  methods: {
    getDpaeInfo(): string {
      return this.activeState.info;
    },
    callBack(index?: number) {
      if (!this.lockAction) {
        this.lockAction = true;
        if (index != null) {
          this.state.actionIndex = index + 1;
        } else {
          this.state.actionIndex = 0;
        }
        if (index != null && this.activeState.actions[index] == 'Site URSSAF') {
          this.lockAction = false;
          window.open('https://www.due.urssaf.fr/declarant/formulaireDueLibre.jsf', '_blank');
        } else {
          State.process(this.state).then((res) => {
            this.activeState = res;
            this.lockAction = false;
          }).catch(() => {
            this.lockAction = false;
          });
        }
      }
    },
  },
});
</script>

<style scoped>
  td {
    padding: 10px !important;
  }
</style>